import React from 'react';

const LoginHeader = () => {
    return (
        <div>
            <h1>Login</h1>
        </div>
    );
};

export default LoginHeader;
